/* eslint-disable react/jsx-no-target-blank */
import React, {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'
import {getSideBarCount} from '../../../../../API/api-endpoint'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const loginUser: any = JSON.parse(localStorage.getItem('kt-auth-react-v') || '')
  let [count, setCount] = useState<any>({})

  useEffect(() => {
    getCount()
  }, [])

  const getCount = async () => {
    let result = await getSideBarCount()
    if (result.success) {
      setCount(result.data)
    }
  }

    return (
      <>
        <SidebarMenuItem
          to='dashboard'
          icon='element-11'
          title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
          fontIcon='bi-app-indicator'
        />

        <SidebarMenuItemWithSub
          to='apps/user-management'
          title={`${intl.formatMessage({id: 'MENU.USERMANAGEMENT'})} `}
          icon='profile-user'
          fontIcon='bi-person'
        >
          <SidebarMenuItem
            to='apps/user-management/users'
            icon='profile-user'
            title={`User List`}
            fontIcon='bi-person'
          />
          <SidebarMenuItemWithSub
            to='apps/user-management/user-media'
            title={`User Media`}
            icon='picture'
            fontIcon='bi-person'
          >
            <SidebarMenuItem
              to='apps/user-management/user-media/photos'
              title={`Photos`}
              hasBullet={true}
            />
           
          </SidebarMenuItemWithSub>
        
          <SidebarMenuItem
            to='apps/user-management/user-video-call'
            icon=''
            title={intl.formatMessage({id: 'MENU.USERVIDEOCALL'})}
            fontIcon='bi-camera-video-fill'
          />
          <SidebarMenuItem
            to='apps/user-management/user-audio-call'
            icon=''
            title={intl.formatMessage({id: 'MENU.USERAUDIOCALL'})}
            fontIcon='bi-telephone-plus-fill'
          />
          <SidebarMenuItem
            to='apps/user-management/random-call'
            icon='call'
            title={intl.formatMessage({id: 'MENU.RANDOMCALL'})}
            fontIcon='bi-layers'
          />
        </SidebarMenuItemWithSub>

        <SidebarMenuItemWithSub
          to='apps/anonymous-user-management'
          title={intl.formatMessage({id: 'MENU.ANONYMOUSUSERMANAGEMENT'})}
          icon='user'
          fontIcon='bi-person'
        >
          <SidebarMenuItem
            to='apps/anonymous-user-management/users'
            icon='user'
            title={`Anonymous User List`}
            fontIcon='bi-layers'
          />
          <SidebarMenuItemWithSub
            to='apps/anonymous-user-management/user-media'
            title={`Anonymous User Media`}
            icon='picture'
            fontIcon='bi-person'
          >
            <SidebarMenuItem
              to='apps/anonymous-user-management/user-media/photos'
              title={`Photos`}
              hasBullet={true}
            />
            
          </SidebarMenuItemWithSub>
        </SidebarMenuItemWithSub>

        <SidebarMenuItem
          to='apps/guest-user-management'
          icon='user-square'
          title={intl.formatMessage({id: 'MENU.GUESTUSERS'})}
          fontIcon='bi-app-indicator'
        />

       

        <SidebarMenuItemWithSub
          to='analytics/daily-analytics'
          title={intl.formatMessage({id: 'MENU.ANALYTICS'})}
          icon='chart-line'
          fontIcon='bi-person'
        >
          <SidebarMenuItem
            to='analytics/daily-analytics'
            icon='chart'
            title={intl.formatMessage({id: 'MENU.DAILYANALYTICS'})}
            fontIcon='bi-layers'
          />
          <SidebarMenuItem
            to='analytics/premium-analytics'
            icon='chart-simple'
            title={intl.formatMessage({id: 'MENU.PREMIUMANANALYTICS'})}
            fontIcon='bi-layers'
          />
          <SidebarMenuItem
            to='analytics/graphs-analytics'
            icon='graph-3'
            title={intl.formatMessage({id: 'MENU.GRAPHSANALYTICS'})}
            fontIcon='bi-layers'
          />
          <SidebarMenuItem
            to='analytics/campaign-analytics'
            icon='graph-up'
            title={intl.formatMessage({id: 'MENU.CAMPAIGNANALYTICS'})}
            fontIcon='bi-layers'
          />
        </SidebarMenuItemWithSub>

        <SidebarMenuItem
          to='plugins'
          icon='abstract-39'
          title={intl.formatMessage({id: 'MENU.PLUGINS'})}
          fontIcon='bi-layers'
        />

        <SidebarMenuItem
          to='apps/leaderboard'
          icon='ranking'
          title='Leaderboard'
          fontIcon='bi-layers'
        />

        <SidebarMenuItem
          to='user-verification'
          icon='faceid'
          title={`${intl.formatMessage({id: 'MENU.USERVERIFICATION'})} (${
            count?.userVerificationCount || 0
          })`}
          fontIcon='bi-layers'
        />
        <SidebarMenuItem
          to='voice-verification'
          icon='verify'
          title={`Voice Verification (${count?.voiceVerificationCount || 0})`}
          fontIcon='bi-layers'
        />

        <SidebarMenuItem
          to='user-order'
          icon='purchase'
          title={intl.formatMessage({id: 'MENU.USERORDER'})}
          fontIcon='bi-layers'
        />
       

        <SidebarMenuItem
          to='user-referral-commission'
          icon='share'
          title={`${intl.formatMessage({id: 'MENU.USERREFERRALCOMMISION'})}`}
          fontIcon='bi-layers'
        />

        <SidebarMenuItem
          to='withdrawal-requests'
          icon='wallet'
          title={`${intl.formatMessage({id: 'MENU.WITHDRAWALREQUESTS'})} (${
            count?.userWithdrawalCount || 0
          })`}
          fontIcon='bi-layers'
        />
        <SidebarMenuItem
          to='support-system'
          icon='message-question'
          title={`${intl.formatMessage({id: 'MENU.SUPPORTSYSTEM'})} (${
            count?.userSupportCount || 0
          })`}
          fontIcon='bi-layers'
        />
        <SidebarMenuItem
          to='admin-user-chat'
          icon='message-notif'
          title='Admin User Chat'
          fontIcon='bi-chat-left-dots'
        />
        <SidebarMenuItem
          to='blocked-user-management'
          icon='shield-cross'
          title={`${intl.formatMessage({id: 'MENU.BLOCKEDUSERS'})} ${
            `(${count?.blockAlertCount})`
          }`}
          fontIcon='bi-layers'
        />
        <SidebarMenuItem
          to='apps/user-management/suspended-users'
          icon='people'
          title={intl.formatMessage({id: 'MENU.SUSPENDEDUSERS'})}
          fontIcon='bi-layers'
        />
        <SidebarMenuItem
          to='invoice-management'
          icon='cheque'
          title={intl.formatMessage({id: 'MENU.INVOICEMANAGEMENT'})}
          fontIcon='bi-layers'
        />
        <SidebarMenuItem
          to='order-recovery'
          icon='note-2'
          title={intl.formatMessage({id: 'MENU.ORDERSRECOVERY'})}
          fontIcon='bi-layers'
        />
        <SidebarMenuItem
          to='apps/notification-management'
          icon='notification'
          title='Notification Templates'
          fontIcon='bi-bell'
        />
      </>
    )
  
}

export {SidebarMenuMain}
